export const DEFAULT_DESCRIPTION =
  'Our mission is to help everyone optimize mental and spiritual health. Whether you’re looking for resources to help you sleep, to reduce stress and anxiety, or to find a way into a life of deeper meaning, purpose and connection, CredibleMind and our team of experts can help.';
export const DEFAULT_TITLE =
  'Thrive Mentally and Spiritually - Expert and user rated resources for a better life';
export const DEFAULT_IMAGE = 'https://crediblemind.com/cm-logo.png';
export const COMMON_META = {
  topics: {
    title: 'Thrive Mentally and Spiritually with Our Selected Topics',
  },
  assessments: {
    title: 'Thrive Mentally and Spiritually with Our Selected Assessments',
  },
  blogs: {
    title: 'Thrive Mentally and Spiritually with Our Blogs',
  },
  resources: {
    title: 'Thrive Mentally and Spiritually with Our Resources',
  },
  lists: {
    title: 'Thrive Mentally and Spiritually with Our Lists',
  },
  news: {
    title:
      'Get the Latest Mental Health and Spiritual Growth Insights from the CredibleMind Newsfeed',
  },
  homepage: {
    title: DEFAULT_TITLE,
  },
  landing: {
    title: DEFAULT_TITLE,
  },
};
